// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2p2Rx","tab":"ProcedureTabs_tab__3B-DX"};